import React from 'react';
import { FlameIcon } from 'lucide-react';
import { Countdown } from '../Countdown';
export function TopBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-coral text-white" data-id="element-278" data-mp="anmbl7ng9b4d">
      <div className="max-w-6xl mx-auto px-4 py-2.5 flex items-center justify-center gap-2 sm:gap-4 text-center" data-id="element-279" data-mp="ff42t3zo7xc5">
        <FlameIcon className="w-4 h-4 shrink-0" aria-hidden="true" data-id="element-280" data-mp="jg60hgdxw1c0" />
        <p className="text-xs sm:text-sm font-semibold tracking-wide" data-id="element-281" data-mp="3iwm5yy4i0g68">
          Precio de lanzamiento · termina en{' '}
          <Countdown variant="inline" className="tabular-nums" data-id="element-282" data-mp="3nunrrqtb6tle" />
        </p>
      </div>
    </div>;
}